/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMars = createReactComponent("mars", "IconMars", [
  ["path", { d: "M10 14m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", key: "svg-0" }],
  ["path", { d: "M19 5l-5.4 5.4", key: "svg-1" }],
  ["path", { d: "M19 5l-5 0", key: "svg-2" }],
  ["path", { d: "M19 5l0 5", key: "svg-3" }]
]);

export { IconMars as default };
//# sourceMappingURL=IconMars.js.map
